import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaFilterIcon: React.FC<IIconProps> = ({
  color,
  size = '51',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.alea[500];
  const width = parseInt(String(size), 10);
  const height = (50 / 51) * width; // Keeping the aspect ratio

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="75x75px_Filter">
        <path
          id="Union"
          d="M38.6406 15C38.6406 13.8954 37.7452 13 36.6406 13H14.6406C13.5361 13 12.6406 13.8954 12.6406 15V19.3531C12.6406 20.045 12.9983 20.6878 13.5862 21.0526L21.9677 26.2526C22.5557 26.6174 22.9134 27.2602 22.9134 27.9521V35.4443C22.9134 35.8489 23.036 36.2439 23.2652 36.5773L24.7198 38.6932C25.8324 40.3118 28.3679 39.5243 28.3679 37.5602V27.9521C28.3679 27.2602 28.7255 26.6174 29.3135 26.2526L37.695 21.0526C38.283 20.6878 38.6406 20.045 38.6406 19.3531V15Z"
          fill="white"
          stroke={iconColor}
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default AleaFilterIcon;
